<div class='Home_results py-5 p-sm-5'>
  <div class='Home_results_wrapper container'>
    <div class='d-flex flex-row'>
      <div class='flex-grow-1 d-flex w-100 justify-content-center flex-column'>
        <h2 class=''><span>Retreva Results</span></h2>
        <ul>
          <li>Increase sales</li>
          <li>Response rates up to 75%</li>
          <li>70% plus of the responses are positive replies</li>
          <li>
            All activity is driving towards short and long term selling
            opportunities
          </li>
          <li>Helps to identify the perfect prospect profile</li>
          <li>Cleans existing databases</li>
        </ul>
      </div>
      <div class='flex-grow-1 d-flex w-100 justify-content-center'>
        <img alt='' class='ms-5' src='assets/images/retail/profes.png' />
      </div>
    </div>
  </div>
</div>
